import { Effect } from "babylonjs/Materials/effect";

let name = 'handleVertexShader';
let shader = `precision highp float;

attribute vec3 position;

uniform vec3 positionOffset;
uniform mat4 worldViewProjection;
uniform float scale;
void main(void) {
vec4 vPos=vec4((vec3(position)+positionOffset)*scale,1.0);
gl_Position=worldViewProjection*vPos;
}`;

Effect.ShadersStore[name] = shader;
/** @hidden */
export var handleVertexShader = { name, shader };
